export default  {
	"appVersion": 1,  // Only increment on major changes that break compatibility with local storage data
	"bundleVersion": 237, // Gets incremented on every build
}
